export default (a: string, b: string): number => a.localeCompare(b, 'en', { numeric: true });
